export const ADD_GIFT_CARD = "ADD_GIFT_CARD"
export const AMAZON_SET_ORDER_REFERENCE = "AMAZON_SET_ORDER_REFERENCE"
export const APPLY_GIFT_CARD = "APPLY_GIFT_CARD"
export const CHECK_GIFT_CARD = "CHECK_GIFT_CARD"
export const DEBOUNCE_ORDER_VALUES = "DEBOUNCE_ORDER_VALUES"
export const ERROR_MODAL_OPEN = "ERROR_MODAL_OPEN"
export const ERROR_MODAL_CLOSE = "ERROR_MODAL_CLOSE"
export const HANDLE_FORMIK_CHANGE = "HANDLE_FORMIK_CHANGE"
export const LOAD_ORDER_DATA = "LOAD_ORDER_DATA"
export const PANEL_ATTEMPTED = "PANEL_ATTEMPTED"
export const PANEL_OPEN = "PANEL_OPEN"
export const PANEL_COMPLETE = "PANEL_COMPLETE"
export const PANEL_INCOMPLETE = "PANEL_INCOMPLETE"
export const PANEL_TOGGLE = "PANEL_TOGGLE"
export const REDEEM_POINTS = "REDEEM_POINTS"
export const REDEEM_REWARDS = "REDEEM_REWARDS"
export const REMOVE_REWARDS = "REMOVE_REWARDS"
export const REMOVE_GIFT_CARD = "REMOVE_GIFT_CARD"
export const SET_DELIVERY_METHODS = "SET_DELIVERY_METHODS"
export const SET_EXPERIMENT = "SET_EXPERIMENT"
export const SET_ORDER_SUBMIT_RESULTS = "SET_ORDER_SUBMIT_RESULTS"
export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD"
export const SHOW_COUNTRY_SWITCH = "SHOW_COUNTRY_SWITCH"
export const SUBMIT_ORDER = "SUBMIT_ORDER"
export const UPDATE_ORDER_DATA = "UPDATE_ORDER_DATA"
export const UPDATE_ORDER_VALUES = "UPDATE_ORDER_VALUES"
export const UPDATE_ORDER_VALUES_NOW = "UPDATE_ORDER_VALUES_NOW"
export const USER_LOGIN = "USER_LOGIN"
export const DO_JAVASCRIPT_TRACKING = "DO_JAVASCRIPT_TRACKING"
export const LOGOUT_AMAZON = "LOGOUT_AMAZON"
export const SET_LOGIN_CHECKOUT = "SET_LOGIN_CHECKOUT"
export const SET_USER_ON_CHECKOUT_LOGIN = "SET_USER_ON_CHECKOUT_LOGIN"
export const PRELOAD_ORDER_DATA = "PRELOAD_ORDER_DATA"
export const ORDER_COMPLETED = "ORDER_COMPLETED"
export const UPDATE_KLARNA_SESSION = "UPDATE_KLARNA_SESSION"
export const SAVE_KLARNA_CLIENT_TOKEN = "SAVE_KLARNA_CLIENT_TOKEN"
export const UPDATE_USER_DATA = "UPDATE_USER_DATA"
export const SET_CHECKOUT_READY = "SET_CHECKOUT_READY"
export const VALIDATE_PANELS = "VALIDATE_PANELS"
export const SET_LOADING_SHIPPING_METHODS = "SET_LOADING_SHIPPING_METHODS"
export const LOAD_DELIVERY_METHODS = "LOAD_DELIVERY_METHODS"

/**
 * Simply sends the Client Token from the generated Klarna Session
 * to the Checkout state, where it will be used to authorize the payment
 * when submitting the order
 */
export function saveKlarnaWidgetInfo(klarnaWidgetInfo) {
  return {
    klarnaWidgetInfo,
    type: SAVE_KLARNA_CLIENT_TOKEN,
  }
}

/**
 * Very simply sets state.form.addGiftCard to true, for adding additional gift cards
 */
export function addGiftCard() {
  return { type: ADD_GIFT_CARD }
}

/**
 * Sets the Amazon Order Reference ID as a backfill in case Formik doesn't catch up to the Redux actions
 *
 * @param {String} referenceId The Amazon Order Reference ID to set
 */
export function amazonSetOrderReference(referenceId) {
  return { type: AMAZON_SET_ORDER_REFERENCE, referenceId }
}

export function setLoginFromCheckout() {
  return { type: SET_LOGIN_CHECKOUT }
}

export function setUserOnCheckoutLogin(user, email, data) {
  return {
    data,
    email,
    type: SET_USER_ON_CHECKOUT_LOGIN,
    user,
  }
}

/**
 * Sets a flag to apply the gift card and makes an order update with the apply_gift_card flag on
 *
 * @param {Function} setFieldValue The FormikBad setFieldValue method to clear the field if applicable
 * @param {DOMObject} ref The ref of the form input, to re-focus in case of failure
 */
export function applyGiftCard(setFieldValue, ref) {
  return { type: APPLY_GIFT_CARD, setFieldValue, ref }
}

/**
 * Wrapper function for the updateOrderValues action - simply sent to redux saga and debounced into
 * a single updateOrderValues call
 *
 * @see updateOrderValues
 */
export function debounceOrderValues(props, setFieldValue, endpoint = "all") {
  return { endpoint, props, setFieldValue, type: DEBOUNCE_ORDER_VALUES }
}

export function doJavascriptTracking(order) {
  return { order, type: DO_JAVASCRIPT_TRACKING }
}

/**
 * Sets `state.order.error_modal` to false
 */
export function errorModalClose() {
  return { type: ERROR_MODAL_CLOSE }
}
/**
 * Sets `state.order.error_modal` to true
 */
export function errorModalOpen(error_msg) {
  return { error_msg, type: ERROR_MODAL_OPEN }
}

export function checkGiftCard() {
  return { type: CHECK_GIFT_CARD }
}

/**
 * Handles the change event on the Formik form as a redux saga so we don't block the main working thread
 *
 * @param {Object} current Current FormikBag
 * @param {Object} prev Previous FormikBag
 * @param {Function} setFieldValue The setFieldValue function to call to massage Formik values
 */
export function handleFormikChange(current, prev, setFieldValue) {
  return { type: HANDLE_FORMIK_CHANGE, current, prev, setFieldValue }
}

/**
 * Loads order values into redux
 *
 * @param {Object} data Order data
 * @param {String} selectedPaymentMethod selected payment method
 */
export function loadOrderData(data, selectedPaymentMethod) {
  return { data, selectedPaymentMethod, type: LOAD_ORDER_DATA }
}

export function orderCompleted() {
  return { type: ORDER_COMPLETED }
}

/**
 * Marks panel as attempted, purely so we can decide to show errors or not
 * @param {Integer} step The panel step that's attempted
 */
export function panelAttempted(step) {
  return { type: PANEL_ATTEMPTED, step }
}

/**
 * Marks panel as complete
 * @param  {Int} step  The panel step that's completed
 * @param  {String} actionType - determines whether to close/open pane.
 *
 * sets the following state:
 * state.panels[step].complete = true
 * state.panels[step].hasCompleted = true
 * state.panels[step].opened = determined by actionType, see below
 *
 * actionType options:
 * "open": state.panel[step].opened = true
 * "close": state.panel[step].opened = false
 * "toggle": state.panel[step].opened = < toggles >
 */
export function panelComplete(step, actionType = "close") {
  return { type: PANEL_COMPLETE, step, actionType }
}
/**
 * Opens panel at step, `state.panels[step].opened = true`
 * @param  {Int} step  The panel step that's completed
 */
export function panelOpen(step) {
  return { type: PANEL_OPEN, step }
}

/**
 * Marks panel as incomplete and opens panel
 * state.panels[step].opened = true
 * state.panels[step].complete = false
 *
 * @param  {Int} step  The panel step that's completed
 */
export function panelIncomplete(step, actionType = "open") {
  return { actionType, step, type: PANEL_INCOMPLETE }
}

/**
 * Toggles the panel open or closed, only works well on optional panels
 * @param  {Integer} step The numeric step of the panel
 */
export function panelToggle(step) {
  return { type: PANEL_TOGGLE, step }
}

/**
 * Preload order data
 */

export function preloadOrderData(data, selectedPaymentMethod) {
  return {
    data,
    selectedPaymentMethod,
    type: PRELOAD_ORDER_DATA,
  }
}

/**
 * Loads order values into redux
 *
 * @param {Object} data Order data
 */

/**
 * Forces a value to amount provided by amount param
 * @param {Float} amount Amount to redeem (or 0.0 to clear)
 */
export function redeemPoints(amount) {
  return { type: REDEEM_POINTS, amount }
}

export function redeemRewards(redeemAmountRef, setFieldValue) {
  return { ref: redeemAmountRef, setFieldValue, type: REDEEM_REWARDS }
}

export function removeRewards(setFieldValue) {
  return { setFieldValue, type: REMOVE_REWARDS }
}

/**
 * Sets a flag to remove the coupon, including an adjustment ID (if applicable), and makes
 * an order update with the remove_gift_card flag on. If no adjustment ID set, the order should
 * clear all gift cards
 */
export function removeGiftCard(setFieldValue, adjId) {
  return { type: REMOVE_GIFT_CARD, setFieldValue, adjId }
}

/**
 * This toggles the enabled/disabled state of the checkout button.
 * @param {Boolean} isReady
 */
export function setCheckoutReady(isReady) {
  return { isReady, type: SET_CHECKOUT_READY }
}

/**
 * This sets the delivery methods in state.order.delivery from the fetch_delivery_methods
 * AJAX request
 *
 * @param {Object} data Data to populate
 */
export function setDeliveryMethods(data) {
  return { type: SET_DELIVERY_METHODS, data }
}

/**
 * Set experiment variable
 * @param {object} experiment - set experiment type and variation
 * @example
 * setExperiment({ promo: 'b', pricing: 'a'})
 */
export function setExperiment(experiment) {
  return { type: SET_EXPERIMENT, experiment }
}

/**
 * This sets the errors/messages returned by the complete order AJAX call
 *
 * @param {Object} results Resulting messages (usually cc_error or error in the object)
 */
export function setOrderSubmitResults(results) {
  return { type: SET_ORDER_SUBMIT_RESULTS, results }
}

/**
 * This sets the payment method to a different parameter, useful for escaping transactions like Affirm
 * NOTE: You should ALSO setFieldValue('payment_method', paymentMethod) so Yup validates correctly
 *
 * @param {String} paymentMethod The payment method to switch to (normally "creditcard")
 */
export function setPaymentMethod(paymentMethod) {
  return { paymentMethod, type: SET_PAYMENT_METHOD }
}

/**
 * This is a simple flag to show the country switch dialog to the user
 */
export function showCountrySwitch() {
  return { type: SHOW_COUNTRY_SWITCH }
}

/**
 * This submits the order to /checkout using PATCH method
 *
 * @param {Object} values Order values
 * @param {Function} setSubmitting Callback to re-enable the form on submission errors
 * @param {Function} setFieldValue Callback to reset field values in case the error was caused by a presence of that value
 */
export function submitOrder(values, setSubmitting, setFieldValue) {
  return { setFieldValue, setSubmitting, type: SUBMIT_ORDER, values }
}

/**
 * Updates the order data returned from AJAX calls and initial page load
 * @param  {Object} data
 * @param {Function} setFieldValue setFieldValue function, useful for updating the shipping
 * address if it's fully verified on the backend
 */
export function updateOrderData(data, setFieldValue) {
  return { data, setFieldValue, type: UPDATE_ORDER_DATA }
}

/**
 * Updates the order values returned from Formik to be sent as AJAX calls
 * and persist to the order for page reloads, getting delivery methods, etc.
 *
 * @param {Object} props Props returned by Formik for parsing (specifically errors and values)
 * @param {Function} setFieldValue The setFieldValue method provided by FormikBag
 * @param {String} endpoint The target api endpoint (default to update all order values)
 */
export function updateOrderValues(props, setFieldValue, endpoint = "all") {
  return { endpoint, props, setFieldValue, type: UPDATE_ORDER_VALUES }
}

/**
 * Updates the order values returned from Formik to be sent as AJAX calls
 * and persist to the order for page reloads, getting delivery methods, etc.
 *
 * @param {Object} props Props returned by Formik for parsing (specifically errors and values)
 * @param {Function} setFieldValue The setFieldValue method provided by FormikBag
 * @param {String} endpoint The target api endpoint (default to update all order values)
 */
export function updateOrderValuesNow(
  props,
  setFieldValue,
  endpoint = "all",
  callback
) {
  return {
    callback,
    endpoint,
    props,
    setFieldValue,
    type: UPDATE_ORDER_VALUES_NOW,
  }
}

/**
 * Signs in user. Submits POST request to /users/sign_in
 * @param  {Object} values
 * @param  {function} setSubmitting
 */
export function userLogin(values, setSubmitting) {
  return { type: USER_LOGIN, values, setSubmitting }
}

export function updateKlarnaSession() {
  return { type: UPDATE_KLARNA_SESSION }
}

export function updateUserData() {
  return { type: UPDATE_USER_DATA }
}

export function validatePanels(data) {
  return { data, type: VALIDATE_PANELS }
}

export function setLoadingShippingMethods(loading) {
  return { loading, type: SET_LOADING_SHIPPING_METHODS }
}

export function loadDeliveryMethods(setFieldValue) {
  return { setFieldValue, type: LOAD_DELIVERY_METHODS }
}
